module.exports = __webpack_public_path__ + "img/f.9938fe62.png";